import axiosInstance from "../axiosInstance";

// STATES
export const getStates = async () => {
  const res = await axiosInstance.get("/master/states");
  return res.data;
};

// DISTRICTS
export const getDistricts = async (stateCode) => {
  const res = await axiosInstance.get(`/master/districts?state=${stateCode}`);
  return res.data;
};

// INSTITUTIONS
export const getInstitutions = async ({ state, district, level }) => {
  const res = await axiosInstance.get(
    `/master/institutions?state=${state}&district=${district}&level=${level}`
  );
  return res.data;
};

export const submitInstitution = async (formData) => {
  const res = await axiosInstance.post("/institutions/submit", formData);
  return res.data;
};